import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

type Overlay = { $overlay: boolean };

export const HeaderSection = styled("header")<Overlay>`
  padding: 0.75rem 0.5rem;

  ${({ $overlay }) =>
    $overlay
      ? `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;
    background: rgba(247, 249, 255, 0.86);
    border-bottom: 1px solid rgba(137, 167, 255, 0.16);
    backdrop-filter: blur(18px);
  `
      : `
    position: relative;
    background: rgba(247, 249, 255, 0.94);
    backdrop-filter: blur(18px);
    border-bottom: 1px solid #dce3f1;
  `}

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const Bar = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
`;

export const LogoLink = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  text-decoration: none;

  .brand__mark {
    height: 58px;
    width: 58px;
    display: block;
    flex: none;
    filter: drop-shadow(0 6px 14px rgba(16, 26, 58, 0.22));
  }

  .brand__divider {
    width: 1px;
    align-self: stretch;
    margin: 0.2rem 0;
    background: rgba(16, 26, 58, 0.22);
  }

  .brand__wm {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  .brand__pre {
    font-family: "Inter", sans-serif;
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: #315fe8;
    margin-bottom: 0.28rem;
  }

  .brand__name {
    font-family: "Space Grotesk", "Inter", sans-serif;
    font-size: 1.55rem;
    font-weight: 700;
    letter-spacing: -0.035em;
    color: #101a3a;
  }

  .brand__city {
    font-family: "Inter", sans-serif;
    font-size: 0.66rem;
    font-weight: 600;
    letter-spacing: 0.42em;
    text-transform: uppercase;
    color: #6d5dfc;
    margin-top: 0.3rem;
    margin-left: 0.1em;
  }

  @media only screen and (max-width: 768px) {
    gap: 0.6rem;

    .brand__mark {
      height: 46px;
      width: 46px;
    }
    .brand__name {
      font-size: 1.45rem;
    }
    .brand__pre {
      font-size: 0.56rem;
    }
    .brand__city {
      font-size: 0.58rem;
      letter-spacing: 0.36em;
    }
  }


  @media only screen and (max-width: 360px) {
    .brand__divider,
    .brand__pre {
      display: none;
    }
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  display: none;
  cursor: pointer;

  @media only screen and (max-width: 990px) {
    display: block;
  }

  svg {
    fill: #101a3a;
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: nowrap;

  @media only screen and (max-width: 990px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #111c44;
  transition: color 0.2s ease-in;
  margin: 0;
  padding: 0.4rem 0;
  display: inline-flex;
  align-items: center;

  @media only screen and (max-width: 768px) {
    margin: 0.5rem 0;
    padding: 0.6rem 0;
    width: 100%;
    text-align: left;
  }
`;

export const Phone = styled("a")`
  color: #315fe8;
  font-weight: 700;
  font-size: 0.92rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: #101a3a;
  }
`;

export const Cta = styled("a")`
  font-weight: 600;
  font-size: 0.92rem;
  padding: 0.6rem 1.25rem;
  border-radius: 999px;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), background 0.25s;

  background: #2457f5;
  color: #fff;
  box-shadow: 0 8px 18px -8px rgba(16, 26, 58, 0.6);

  &:hover {
    background: #101a3a;
    color: #fff;
    transform: translateY(-2px);
  }
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #7c5cff;
  }
`;
